import Loader from 'component/loader'
import React from 'react'

function ButtonGradient({
  type = 'button',
  disabled = false,
  label,
  processing = false,
  children,
  onClick,
  className = '',
}) {
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled || processing}
      className={`
        inline-flex items-center justify-center
        px-6 py-3
        text-sm font-medium
        text-white
        rounded-lg
        transition-all duration-200
        focus:outline-none focus:ring-4 focus:ring-[#F5821F]/30 focus:ring-offset-2

        ${disabled || processing
          ? 'bg-[#F5821F] cursor-not-allowed opacity-70 shadow-none'
          : `
            bg-[#F5821F]
            hover:bg-[#e07018]
            active:bg-[#d16a12]
            shadow-md hover:shadow-lg active:shadow-sm
            active:translate-y-[1px]
          `
        }

        ${className}
      `}
    >
      {processing ? (
        <div className="flex items-center justify-center gap-2.5">
          <Loader className="h-5 w-5" />
          {label && <span>{label}</span>}
        </div>
      ) : (
        label || children
      )}
    </button>
  )
}

export default ButtonGradient